<template>
  <b-modal
    id="dino-run"
    ok-only
    no-close-on-backdrop
    :visible="true"
    ok-title="Accept"
    body-class="text-center p-0"
    size="lg"
    hide-footer
    @hide="stopPendingGame"
    @close="stopPendingGame"
  >
    <template #modal-title>
      Dino Runs <feather-icon
        :icon="isMuted ? 'VolumeXIcon' : 'Volume2Icon' "
        size="20"
        role="button"
        @click="$emit('toggleSound')"
      />
    </template>
    <b-spinner
      v-if="isProcessing"
      type="grow"
      class="text-center"
      label="Loading..."
    />
    <iframe
      id="gameFrameContent"
      style="height: 80vh;width: 100%;"
      frameBorder="0"
    />
  </b-modal>

</template>
<script>
import { BModal, BSpinner } from 'bootstrap-vue'

const scripts = [
  '/dino-run/scripts/supportcheck.js',
  '/dino-run/scripts/offlineclient.js',
  '/dino-run/scripts/main.js',
  '/dino-run/scripts/register-sw.js',
]

export default {
  components: {
    BModal,
    BSpinner,
  },
  props: {
    isMuted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProcessing: true,
    }
  },
  async created() {
    let html = ' <div id="gameContainer" />'
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < scripts.length; i++) {
      html += `<script src="${scripts[i]}"></`
      html += 'script>'
    }
    setTimeout(() => {
      const iframe = document.getElementById('gameFrameContent')
      iframe.contentWindow.document.open()
      iframe.contentWindow.document.write(html)
      iframe.contentWindow.document.close()
      iframe.contentWindow.document.addEventListener('dino-runGameOver', () => {
        this.$emit('gameOver')
      })
      this.isProcessing = false
    }, 1000)
    // document.addEventListener('dino-runGameOver', () => {
    //   this.$emit('gameOver')
    // })
  },

  methods: {
    stopPendingGame() {
      document.dispatchEvent(new Event('stopGameFromGec'))
      this.$emit('gameOver')
    },
  },
}
</script>
